export const SUMMER_DEAL_END = 1726531199999
